import { useTranslation } from "react-i18next";

import { ChannelType } from "@/types/response/ChannelType";
import { TableColumn } from "@/types/table/tableProps";

export const useChannelInvoiceTableColumns = () => {
  const { t } = useTranslation();

  const channelTableColumns: TableColumn<ChannelType>[] = [
    {
      accessor: "name",
      Cell: (row: ChannelType) => <span>{row.name} ({row.count})</span>,
      header: t("common.name"),
      width: "30%",
    },
  ];

  return {
    channelTableColumns
  }
}
